export default "__VITE_ASSET__Dn1$CWOs__"